export default {
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.userMenu.help': '說明文件',
};
